import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import clients from 'redux/clients'
const {
  cloudloyalty: { client }
} = clients

class Voucher extends Component {
  handleShowField = () => {
    this.setState({ showField: !this.state.showField })
  }

  handleKeyChange = event => {
    this.setState({ email: event.target.value })
  }

  handleChange = event => {
    client
      .post(`v1/carts/1/me/emailAddress?email=${this.state.email}`)
      .then(_ => {
        this.props.fetchCart()
      })
    this.setState({ showField: !this.state.showField })
  }

  constructor (props) {
    super(props)
    this.state = {
      showField: false,
      email: this.props.customer
        ? this.props.customer.email
        : this.props.email.value
    }
  }

  render () {
    return (
      <div
        className={`row border-color-ui-3 border-bottom mx-0 py-3 px-3 ${
          this.props.visible === true ? '' : 'd-none'
        }`}
      >
        <div className='col-12 mb-2 px-0'>
          <h3 className='txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1'>
            E-mail de envio
          </h3>
          <p className='txt-body-sm'>
            O seu vale presente será enviado para o e-mail abaixo.
          </p>
        </div>
        <div
          className={`col-12 px-0 ${this.state.showField ? 'd-none' : ''}`}
        >
          <p className='txt-lowercase txt-body-sm pb-half'>
            <strong>{this.state.email}</strong>
          </p>
          <p className='d-none'>
            <a
              onClick={this.handleShowField}
              className='cursor txt-left px-0 pt-1 txt-font-body color-brand-2 txt-underline txt-body-sm'
              role='button'
            >
              Alterar e-mail
            </a>
          </p>
        </div>

        <div className={`col-8 px-0 ${this.state.showField ? '' : 'd-none'}`}>
          <Input
            defaultValue='contato@contato.com.br'
            id='emailInvalidInput'
            className='col-12 pl-0'
            childrenClassName='no-label'
            onChange={this.handleKeyChange}
            value={this.state.email}
          />
        </div>
        <div className={`col-4 px-0 ${this.state.showField ? '' : 'd-none'}`}>
          <Button
            id={'button'}
            name={'button'}
            className='btn btn-sm'
            text='Alterar'
            onClick={this.handleChange}
          />
        </div>
      </div>
    )
  }
}

Voucher.propTypes = {
  visible: PropTypes.bool,
  email: PropTypes.string,
  customer: PropTypes.object,
  fetchCart: PropTypes.func
}

export default Voucher



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Voucher/Voucher.js